///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { GtthAbstractCommand } from '../../../abstract-command';
import { ActivityDTO } from '../../../../../../services/project-socket/activity-dto.model';
import { GtthRefreshTopologyCommand } from '../../project/refresh-topology-command';

export class GtthClearDesignCommand extends GtthAbstractCommand {
    getCommandName(): string {
        return 'GtthClearDesignCommand';
    }

    protected doCommand(): void {
        const activityDto = this.createActivityDTO(false);
        this.sendActivity(activityDto);
    }

    doCommandActivity(activityDto: ActivityDTO): void {
        if (!activityDto.successful) {
            this.historyService.notificationService.showError(activityDto?.error?.message);
            this.commandResolve(false);
        } else {
            const refreshTopologyCommand = this.historyService.command(GtthRefreshTopologyCommand).create(false);
            this.historyService.doCommandBypassHistory(refreshTopologyCommand).then(() => {
                this.historyService.clearHistory();
                if (this.commandResolve) {
                    this.commandResolve(activityDto.successful);
                }
            });
        }
    }

    isDisabledInReadOnlyMode(): boolean {
        return true;
    }

    isClearDesign(): boolean {
        return true;
    }
}
